// React
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// Data Injection
import { CategoriesFinanceInjection } from "../../containers/categoriesFinanceInjection";

// View
import { CategoriesFinancePage } from "./view";

export const CategoriesFinance = () => {
  const [registerId, setRegisterId] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  function toggle_delete(id) {
    setRegisterId(id);
    setIsDelete(!isDelete);
  }

  const {
    getCategoriesFinance,
    deleteCategoriesFinance,
    categoryFinances,
    success,
  } = CategoriesFinanceInjection();

  const history = useHistory();

  const handleDelete = () => {
    deleteCategoriesFinance(registerId);
    setIsDelete(!isDelete);
  };

  useEffect(() => {
    getCategoriesFinance();
  }, [success]);

  return (
    <CategoriesFinancePage
      history={history}
      isDelete={isDelete}
      setIsDelete={setIsDelete}
      handleDelete={handleDelete}
      toggle_delete={toggle_delete}
      categoryFinances={categoryFinances}
    />
  );
};
